import { EventPayload } from './GTM/EventPayload';
import { NAFGTMEvent } from './GTM/NAFGTMEvent';

export const funnelPayload = (name: string, step: number) =>
  ({
    event: NAFGTMEvent.checkoutFunnel,
    checkout_step: step,
    checkout_name: name,
  }) as EventPayload;
